import { useState } from 'react'
import { useTranslation } from 'react-i18n-lite'

import useModal from '../../../shared/hooks/useModal'
import Progress from '../../../shared/Progress'
import WebcamCapture from '../../../shared/WebcamCapture'
import useUploadS3 from '../../hooks/useUploadS3/useUploadS3'

/**
 * @deprecated
 */
const ActivityInputTakePhoto = ({ inputValue, onChange, label }) => {
  const { t } = useTranslation()

  const [photoPreview, setPhotoPreview] = useState('')

  const {
    isOpenModal: isOpenCamera,
    openModal: openCamera,
    closeModal: closeCamera
  } = useModal()

  const handleCapture = (imageSrc) => {
    closeCamera()
    setPhotoPreview(imageSrc)
  }

  const { progress, currentStatus, setCurrentStatus, uploadFile } =
    useUploadS3(true)

  const removeFile = () => {
    onChange('')
    setPhotoPreview('')
    setCurrentStatus(t('activity-input-upload-s3.status.awaiting-upload'))
  }

  const handleUploadFile = () => {
    uploadFile({
      file: photoPreview,
      onSuccess: handleOnSuccess,
      onError: handleOnError,
      fileType: 'base64'
    })
  }

  const handleOnSuccess = (url) => {
    onChange(url)
  }

  const handleOnError = (err) => {
    console.log(err)
  }

  return (
    <>
      {label && <label>{label}</label>}
      <div className='mt-2 mb-3'>
        {!photoPreview && !inputValue && (
          <button className='btn btn-light btn-sm' onClick={openCamera}>
            {t('activity-input-photo.btn-take-a-picture')}
          </button>
        )}

        {photoPreview && !inputValue && (
          <img src={photoPreview} className='img-fluid' alt='' />
        )}

        {(inputValue || photoPreview) && (
          <div className='card mt-2'>
            <div className='card-body'>
              {progress > 0 && progress < 100 && (
                <Progress valueNow={progress} heightProgress={2} />
              )}
              <div>
                {t('activity-input-upload-s3.status-des')}:{' '}
                <strong>{currentStatus}</strong>
              </div>
              {inputValue && (
                <div className='border-top pt-2 mt-2'>
                  {t('activity-input-upload-s3.saved-file-des')}:{' '}
                  <strong>{inputValue}</strong>{' '}
                  <button
                    type='button'
                    className='btn btn-link btn-sm link-danger'
                    onClick={removeFile}
                  >
                    {t('activity-input-upload-s3.btn-remove-file-des')}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {photoPreview && !inputValue && (
          <div className='btn-group mt-2'>
            <button className='btn btn-dark btn-sm' onClick={handleUploadFile}>
              {t('activity-input-photo.btn-upload-des')}
            </button>
            <button
              className='btn btn-danger btn-sm'
              onClick={() => setPhotoPreview('')}
            >
              {t('activity-input-photo.btn-discard')}
            </button>
          </div>
        )}
      </div>
      {isOpenCamera && (
        <WebcamCapture onSuccess={handleCapture} onCancel={closeCamera} />
      )}
    </>
  )
}

export default ActivityInputTakePhoto
